<script setup lang="ts">
import { useI18n } from 'vue-i18n'
export interface FyzickaOsobaProps {}

const props = defineProps<FyzickaOsobaProps>()
const { t } = useI18n()
</script>

<template>
  <IDSKHeading as="h1" variant="xl" class="mb-4">
    {{ t('zoppm.step1.mainHeading') }}
  </IDSKHeading>
</template>


<style lang="scss">
</style>
